// extracted by mini-css-extract-plugin
module.exports = {"root":"Evh4rSIxYwT3ivZ6lh9w"};